import React from 'react';

interface DemoWrapperProps {
  /** Indicates if a demo is currently running */
  isDemoRunning: boolean;
  /** Indicates if a demo has been completed */
  hasRunDemo: boolean;
  /** The content to be wrapped */
  children: React.ReactNode;
  /** Optional className to be applied to the wrapper */
  className?: string;
  /** Optional ID for the wrapper element */
  id?: string;
}

/**
 * DemoWrapper component that manages interaction states during demos
 * 
 * @param props - Component props
 * @returns React component
 */
export const DemoWrapper: React.FC<DemoWrapperProps> = ({ 
  isDemoRunning, 
  hasRunDemo, 
  children,
  className = '',
  id
}) => {
  const wrapperClasses = [
    'w-full',
    'h-full',
    hasRunDemo ? 'pointer-events-none select-none' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div 
      id={id}
      className={wrapperClasses}
      aria-busy={isDemoRunning}
      aria-disabled={hasRunDemo}
      role="region"
      aria-label="Demo content wrapper"
    >
      {children}
    </div>
  );
}; 